// Página de Producción por Máquina
import React, { useState, useEffect } from 'react';

import GraficaEficienciaPorMaquina from '../GraficaEficienciaPorMaquina';
import GraficaRevolucionesPorMaquina from '../GraficaRevolucionesPorMaquina';
import GraficaAmperajePorMaquina from '../GraficaAmperajePorMaquina';
import GraficaTemperaturaPorMaquina from '../GraficaTemperaturaPorMaquina';
import GraficaHumedadPorMaquina from '../GraficaHumedadPorMaquina';
import { Paper, Typography, Grid } from '@mui/material';
import FiltrosGraficasMaquina from '../FiltrosGraficasMaquina';

const ProduccionMaquina = () => {
  // Leer filtros guardados en localStorage (si existen)
  const filtrosGuardados = (() => {
    try {
      return JSON.parse(localStorage.getItem('filtrosProduccionMaquina')) || {};
    } catch {
      return {};
    }
  })();
  // Estados para filtros
  const [machineData, setMachineData] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [revolucionesData] = useState([]); // Placeholder para cuando el backend esté listo
  const [fechaInicio, setFechaInicio] = useState(filtrosGuardados.fechaInicio || '');
  const [fechaFin, setFechaFin] = useState(filtrosGuardados.fechaFin || '');
  const [maquina, setMaquina] = useState(filtrosGuardados.maquina || '');
  const [temperaturaData, setTemperaturaData] = useState([]);
  const [humedadData, setHumedadData] = useState([]);
  // Guardar filtros en localStorage cada vez que cambian
  useEffect(() => {
    localStorage.setItem('filtrosProduccionMaquina', JSON.stringify({ fechaInicio, fechaFin, maquina }));
  }, [fechaInicio, fechaFin, maquina]);

  // Obtener lista de máquinas al montar
  useEffect(() => {
    fetch('/api/maquinas-lista')
      .then(res => res.json())
      .then(data => setMaquinas(Array.isArray(data) ? data : []))
      .catch(() => setMaquinas([]));
  }, []);

  // Fetch con filtros
  useEffect(() => {
    let url = '/api/maquinas-lecturas';
    const params = [];
    if (fechaInicio) params.push(`fechaInicio=${fechaInicio}`);
    if (fechaFin) params.push(`fechaFin=${fechaFin}`);
    if (maquina) params.push(`maquinaId=${maquina}`);
    if (params.length > 0) url += '?' + params.join('&');
    fetch(url)
      .then(res => res.json())
      .then(data => setMachineData(Array.isArray(data) ? data : []))
      .catch(() => setMachineData([]));

    // Simulación: cuando el backend esté listo, aquí se debe hacer el fetch de revoluciones
    // setRevolucionesData(dataRevoluciones);

    // Fetch temperatura y humedad
    let urlTemp = '/api/promedio-temperatura-dia';
    let paramsTemp = [];
    if (fechaInicio) paramsTemp.push(`fechaInicio=${fechaInicio}`);
    if (fechaFin) paramsTemp.push(`fechaFin=${fechaFin}`);
    if (maquina) paramsTemp.push(`maquinaId=${maquina}`);
    if (paramsTemp.length > 0) urlTemp += '?' + paramsTemp.join('&');
    fetch(urlTemp)
      .then(res => res.json())
      .then(data => setTemperaturaData(Array.isArray(data) ? data : []))
      .catch(() => setTemperaturaData([]));

    let urlHum = '/api/promedio-humedad-dia';
    let paramsHum = [];
    if (fechaInicio) paramsHum.push(`fechaInicio=${fechaInicio}`);
    if (fechaFin) paramsHum.push(`fechaFin=${fechaFin}`);
    if (maquina) paramsHum.push(`maquinaId=${maquina}`);
    if (paramsHum.length > 0) urlHum += '?' + paramsHum.join('&');
    fetch(urlHum)
      .then(res => res.json())
      .then(data => setHumedadData(Array.isArray(data) ? data : []))
      .catch(() => setHumedadData([]));
  }, [fechaInicio, fechaFin, maquina]);

  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 1600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom align="center">Datos por Máquina Dias</Typography>
      <FiltrosGraficasMaquina
        fechaInicio={fechaInicio}
        setFechaInicio={setFechaInicio}
        fechaFin={fechaFin}
        setFechaFin={setFechaFin}
        maquina={maquina}
        setMaquina={setMaquina}
        maquinas={maquinas}
      />
      <Grid container spacing={2}>
        {/* Primera fila: 3 gráficas, cada una ocupa 2 columnas de 6 */}
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GraficaEficienciaPorMaquina 
            machineData={machineData} 
            maquina={maquina} 
            fechaInicio={fechaInicio} 
            fechaFin={fechaFin} 
          />
        </Grid>
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GraficaRevolucionesPorMaquina
            revolucionesData={revolucionesData}
            maquina={maquina}
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GraficaAmperajePorMaquina
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
            maquina={maquina}
            maquinas={maquinas}
          />
        </Grid>
        {/* Segunda fila: 2 gráficas, cada una ocupa 2 columnas de 6 y centradas */}
        <Grid item xs={false} md={2} lg={2} xl={2} />
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GraficaTemperaturaPorMaquina
            dataApi={temperaturaData}
            maquina={maquina}
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GraficaHumedadPorMaquina
            dataApi={humedadData}
            maquina={maquina}
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
          />
        </Grid>
        <Grid item xs={false} md={2} lg={2} xl={2} />
      </Grid>
    </Paper>
  );
};

export default ProduccionMaquina;
